export default "__VITE_ASSET__DrZxcef7__"